/** Single GitHub login allowed for Engine OAuth (set in Cloudflare Pages / .env). */
const RAW = import.meta.env.VITE_ALLOWED_GITHUB_LOGIN as string | undefined;

type GithubAuthUser = {
  app_metadata?: { provider?: string };
  identities?: Array<{ provider?: string }>;
  user_metadata?: Record<string, unknown>;
};

function allowedLogin(): string | null {
  const login = RAW?.trim().toLowerCase();
  return login || null;
}

export function isGithubLoginConfigured(): boolean {
  return allowedLogin() != null;
}

export function githubLoginFromMetadata(metadata: Record<string, unknown> | undefined): string | null {
  if (!metadata) return null;
  for (const key of ['user_name', 'preferred_username', 'login'] as const) {
    const val = metadata[key];
    if (typeof val === 'string' && val.trim()) return val.trim().toLowerCase();
  }
  return null;
}

export function isGithubAuthUser(user: GithubAuthUser): boolean {
  return (
    user.app_metadata?.provider === 'github' ||
    (user.identities?.some((identity) => identity.provider === 'github') ?? false)
  );
}

/** True when this GitHub session must be rejected (fail closed if allowlist unset). */
export function shouldRejectGithubUser(user: GithubAuthUser): boolean {
  if (!isGithubAuthUser(user)) return false;

  const allowed = allowedLogin();
  if (!allowed) return true;

  const login = githubLoginFromMetadata(user.user_metadata);
  if (!login) return true;

  return login !== allowed;
}
